import React, { useState, useEffect } from 'react';
import './StatusEditModal.css';

interface StatusEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (statuses: string[]) => void;
  currentStatuses: string[];
  taskIndex: number;
}

const StatusEditModal: React.FC<StatusEditModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentStatuses,
  taskIndex
}) => {
  const [statuses, setStatuses] = useState<string[]>(currentStatuses);
  const [newStatus, setNewStatus] = useState('');

  useEffect(() => {
    setStatuses(currentStatuses);
  }, [currentStatuses, isOpen]);

  const handleAddStatus = () => {
    if (newStatus.trim() && !statuses.includes(newStatus.trim())) {
      setStatuses([...statuses, newStatus.trim()]);
      setNewStatus('');
    } else if (statuses.includes(newStatus.trim())) {
      alert('This status already exists!');
    }
  };

  const handleRemoveStatus = (statusToRemove: string) => {
    if (statuses.length <= 1) {
      alert('You must have at least one status option!');
      return;
    }
    setStatuses(statuses.filter(s => s !== statusToRemove));
  };

  const handleSave = () => {
    onSave(statuses);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="status-edit-modal-overlay" onClick={onClose}>
      <div className="status-edit-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="status-edit-modal-header">
          <h5>Edit Status Options</h5>
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        </div>
        
        <div className="status-edit-modal-body">
          <div className="add-status-section">
            <h6>Add New Status</h6>
            <div className="add-status-form">
              <input
                type="text"
                value={newStatus}
                onChange={(e) => setNewStatus(e.target.value)}
                placeholder="Enter new status..."
                onKeyPress={(e) => e.key === 'Enter' && handleAddStatus()}
                className="status-input"
              />
              <button onClick={handleAddStatus} className="add-status-btn">Add</button>
            </div>
          </div>

          <hr />

          <div className="statuses-list-section">
            <h6>Current Status Options</h6>
            <div className="statuses-list">
              {statuses.map((status, index) => (
                <div key={index} className="status-item">
                  <span className="status-name">{status}</span>
                  <button 
                    onClick={() => handleRemoveStatus(status)} 
                    className="remove-status-btn"
                    disabled={statuses.length <= 1}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
          </div>

          <div className="modal-footer">
            <button onClick={handleSave} className="save-statuses-btn">Save Changes</button>
            <button onClick={onClose} className="cancel-statuses-btn">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusEditModal;






